<template>
     <div class="bg-main_blue py-16 px-4 md:px-12 mb-10">
    <div
      class="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10"
    >
      <!-- Images Grid -->
      <div class="flex flex-col gap-6 w-full lg:w-1/2">
        <div class="rounded-xl overflow-hidden shadow-md">
          <img
            src="../assets/images/mshel-print.jpg"
            alt="Team Meeting"
            class="w-full h-auto object-cover"
          />
        </div>
      </div>

      <!-- Text Content -->
      <div class="w-full lg:w-1/2 text-center lg:text-left">
        <h2 class="text-3xl md:text-4xl font-bold text-yellow mb-6">
          Our Vision
        </h2>

        <p class="text-white text-sm leading-relaxed mb-4 text-justify">
To be the world's leading conglomerate transforming industries, enriching lives and advancing communities through innovation, ethical leadership and sustainable impact.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>